import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

// import * as db_content from '../../../database/apis.json';
import { DevportalApiService } from "./remote/devportal-api.service";
import { DevPortalApisServiceBase } from "./remote/devportalapis.base.service";
import { ApiDescription } from "../models/model";
import { map } from "rxjs/operators";
import { OpenApiV3 } from "../models/openapi.model";
import { Logger, LoggerComponent } from "../logger";



@Injectable()
export class OpenApiDataService extends DevPortalApisServiceBase {

  // private dbLoaded = new EventEmitter<void>();
  private dbLoaded = new BehaviorSubject<void>(null);
  get ondbLoaded() { return this.dbLoaded.asObservable() }

  private apis: ApiDescription[];

  constructor(
    devportalApiService: DevportalApiService,
  ) {
    super(devportalApiService);
    // this is done by an app component(s) on user change event
    // this.loadDatabase().subscribe(()=>{});
  }

  loadDatabase(): Observable<void> {

    return this.getAll()
    .pipe(
      map( data => {
        this.apis = data;
        Logger.debug(LoggerComponent.Service, 'loadDatabase', this.apis);

        // this.dbLoaded.emit();
        this.dbLoaded.next();
      })
    );
  }

  getApis() : ApiDescription[] {
    return this.apis || [];
  }

  getApi( name: string ) : ApiDescription {
    return this.getApis().find( a => a.name == name );
  }

  getApiDefinition( name: string ) : Observable<OpenApiV3> {
    return this.get( name );
  }

  getApiDeveloperDoc( name: string ) : Observable<string> {
    return this.getDevDoc( name );
  }
}
